import {ZIDX, ZIDXPage} from "../../standalone/standaloneLibrary.js";

export class ZIDXAccountCMAReportsListingDetail implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountCMAReportsListingDetailContainer";
    }
    render(){
        // console.log("cma-reports/listing");
    }
}
